const body = document.querySelector("body")

const toggleLargeMenu = (obj, addClass) => {
	obj.classList.toggle("open", addClass)
	body.classList.toggle("toggled--largemenu", addClass)
}

const menuLinks = document.querySelectorAll("[data-largemenu-item]")

;[...menuLinks].forEach(link => {
	// Toggle on
	link.addEventListener("mouseover", e =>
		toggleLargeMenu(e.currentTarget, true)
	)
	link.addEventListener("focusin", e =>
		toggleLargeMenu(e.currentTarget, true)
	)

	// Toggle off
	link.addEventListener("mouseout", e =>
		toggleLargeMenu(e.currentTarget, false)
	)
	link.addEventListener("focusout", e =>
		toggleLargeMenu(e.currentTarget, false)
	)
})
